import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 120px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 14px;
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  height: 100%;
  min-width: 0;
  gap: 24px;

  @media (max-width: 1200px) {
    flex-direction: column;
    align-items: stretch;
    gap: 20px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;

  &:first-child {
    flex: 1;
    min-width: 0;
  }

  &:last-child {
    flex: 0 0 auto;
    min-width: 350px;
  }
`;

export const SpaceY = styled.div<{ space: number }>`
  height: ${({ space }) => space}px;
`;

export const SpaceX = styled.div<{ space: number }>`
  width: ${({ space }) => space}px;
`;

export const Title = styled.p`
  font-family: Inter;
  font-weight: 500;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: -1%;
`;

export const ButtonStartCall = styled.button`
  width: 159px;
  height: 40px;
  background: linear-gradient(268.28deg, #06d986 0%, #4a76fb 100%);
  color: white;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-family: Inter;
  &:disabled {
    background: #eaefff;
    color: #abbdff;
    cursor: not-allowed;
  }
`;

export const Card = styled.div`
  width: 120px;
  min-width: 120px;
  height: 42px;
  padding: 6px;
  background: #f0f0f0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
`;

export const CardContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
`;

export const IconText = styled.span`
  font-size: 16px;
  line-height: 1;
`;

export const NumberText = styled.span`
  font-family: Inter;
  font-weight: 600;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: -1%;
`;

export const TitleCard = styled.p`
  font-family: Inter;
  font-weight: 500;
  font-size: 12px;
  line-height: 120%;
  letter-spacing: -1%;
  margin: 0;
  text-align: left;
  width: 100%;
`;

export const IframeContainer = styled.div`
  width: 100%;
  height: 800px;
  margin-top: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const IframeHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const IframeTitle = styled.h3`
  font-family: Inter;
  font-weight: 600;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: -1%;
  margin: 0;
  color: #1f2937;
`;

export const ButtonEndCall = styled.button`
  width: 159px;
  height: 40px;
  background: #ef4444;
  color: white;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-family: Inter;
  font-weight: 500;
  transition: background 0.2s;

  &:hover {
    background: #dc2626;
  }

  &:active {
    background: #b91c1c;
  }
`;

export const Iframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 8px;
  background: #f9fafb;
`;

export const CardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  max-width: 100%;
  min-width: 0;
`;
